module.exports = __webpack_public_path__ + "components/flag/static/square/vg-40e950df2ab7045dbe40e5936c42d511.svg";